<template>
      
    <el-container class="logincon">
        <!-- 头部 -->
           <!-- 头部 -->
        <!-- <div class="banner">
           <el-header class="flex" style="height:88px;width:90%;margin:0 auto;padding:0">  
            <div class="flex align-cen">
                 <img src="../assets/images/logo01.png" alt="">
            </div>
           </el-header>
        </div> -->
        <el-main>
             <transition name="slide"><router-view /></transition>
        </el-main>
        <!-- <div class="foo">
        <el-footer class="flex align-cen" style="height:90px;width:90%;margin:0 auto;padding:0">
            <div class="">
                <p>北京和隆优化科技股份有限公司</p>
                <p>© 20xx-20xx北京和隆优化科技股份有限公司 版权所有 京ICP备15057915</p>
            </div>
            <div class="mft">
                客服电话：<span>400-6622-511</span>
            </div>
        </el-footer>
        </div> -->
    </el-container>
</template>
<script>
    export default {
        name: "Layout",
        components: {
        },
        created() {
        },
        mounted() {},
        computed: {
        },

        watch: {},
        methods: {}
    }
</script>
<style lang="scss" scoped>
.logincon{
    width: 100%;
    height: 100vh;
    overflow: hidden;
    .banner{
        position: fixed;
        background: #00000060;
        top: 0;
        left: 0;
        width: 100%;
    }
    .foo{
       position: fixed;
        background: rgba(21, 92, 148, 0.4);
        bottom: 0;
        left: 0;
        width: 100%;
        height: 90px;
        color: #fff;
    }
}
</style>
